/*
 * Copyright 2020 Spotify AB
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { TemplateEntityV1beta3 } from '@backstage/plugin-scaffolder-common';
import { BackstageTheme, pageTheme } from '@backstage/theme';

import {
  Box,
  Card,
  // CardActions,
  CardContent,
  // Chip,
  Grid,
  makeStyles, Typography,
  useTheme,
  Button,
  Link,
  Divider,
  withStyles, Theme,
} from '@material-ui/core';
// import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React from 'react';
// import { generatePath } from 'react-router';
import { useNavigate, generatePath } from 'react-router-dom';
import { rootRouteRef } from '../../routes';
import { TemplateCardIcon } from './TemplateCardIcon';
import { useRouteRef } from '@backstage/core-plugin-api';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { TemplateWarScore } from './TemplateWarScore';
import CloseIcon from '@material-ui/icons/Close';
import { parseInt } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
  card: {
    minHeight: '458px',

    '&:hover': {
      boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.2)',
      // cursor: 'pointer',
    }
  },
  content: {
    padding: theme.spacing(3),
  },
  type: {
    textTransform: 'capitalize',
    display: 'block',
    marginTop: '-22px',
    marginLeft: '28px',
    fontSize: '12px',
  },
  titleContainer: {
    display: 'block',
    alignItems: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(2),
    //fontSize: '18px',
    font: 'bold',
    width: '285px',
    height: '92px',
    fontWeight: 400
  },
  description: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    minwidth: '260px',
    maxWidth: '285px',
    height: '45px',
    fontSize: '14px'
  },
  arrowIcon: {
    position: 'relative',
    top: '3px',
    marginLeft: theme.spacing(0.5),
  },
  cardActions: {
    maxWidth: '435px',
    height: '58px',
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderTop: 'none',
  },
  leftButton: {
    marginRight: 'auto',
  },
  createButton: {
    marginRight: 'auto',
    borderRadius: '50px',
    backgroundColor: 'RGBA(0,53,89,1)'
  },
  createButtonMargin: {
    marginLeft: '24px',
    marginBottom: '24px',
    marginTop: '10px'

  },
  createWarButtonMargin: {
    marginLeft: '16px',
    marginTop: '12px',
  },
  createWarButton: {
    marginRight: 'auto',
    borderRadius: '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    background: 'none',
    color: '#eb0a1e',
    border: '0.5px solid #eb0a1e',
    marginLeft: '-16px',
    marginTop: '5px',
    // margin: '0px 10px',
    height: '20px',
    fontSize: '11px',
    width: '205px',
    paddingLeft: 'initial',
    paddingRight: 'initial',

    '&:hover': {
      backgroundColor: '#F7F7F7',
      // color: '#3c52b2',
    },

  },
  InfoIcon: {
    marginLeft: '193px',
    marginTop: '-23px',
    cursor: 'pointer',
    fontSize: '1.3rem'
  },
  preRequisites: {
    // overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 5,
    '-webkit-box-orient': 'vertical',
    marginTop: '20px',
    fontSize: '14px',
    font: 'bold',
    minwidth: '300px',
    maxWidth: '270px',
    maxHeight: '80px',
    minHeight: '95px'
  },
  learnMore: {
    marginLeft: '25px',

  },
  capitalize: {
    textTransform: 'capitalize',
  },
  warCard: {
    // width: '1200px',
    maxWidth: '100%',
    maxHeight: '520px',
    marginLeft: '0px',
    display: 'flex'
  },

  titleWarRightGrid: {
    fontSize: '18px',
    marginTop: '-64px',
    marginLeft: '-4px'
  },
  warDescription: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    // '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    fontSize: '14px',
    marginTop: '-57px',
    // width: '902px'
    maxWidth: '440px',
    // minWidth: '553px',
    // maxheight: '312px',
    // minheight: '80px'
  },
  warDescription1: {
    // width: '875px',
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(3),
    marginTop: '-38px',
    // maxheight: '315px',
    // minheight: '120px',
    maxwidth: '595px',
    // minwidth: '600px',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    // display: '-webkit-box',
    // '-webkit-line-clamp': 3,
    // '-webkit-box-orient': 'vertical',

  },

  titleWarRightGridDesc: {

    fontSize: '13px',
    // marginTop: '-5px',
    pointerEvents: 'none'
  },
  root: {
    maxWidth: 345,
  },
  divider: {
    height: '570px',
    backgroundColor: 'RGBA(#EDF0F5)',
    // margin: theme.spacing(5, 0),
    width: '0.1px',
    marginTop: '-350px',
    marginLeft: '-210px'
  },
  closeButton: {
    position: 'relative',
    // bottom: '180px',
    marginLeft: '598px',
    marginTop: '-112px'
  },
  gridDivider: {
    // position: 'fixed',
    marginTop: '-100px',
  },
  gridItem: {
    width: '905px',
    // minWidth: '720px',
    // maxWidth: '630px',
  },
  gridItem1: {
    // width: '920px',
    margintop: '-430px',
    // marginLeft: '-50px',
    padding: '6px',
    marginLeft: '-12px',
    maxwidth: '609px',
    minwidth: '600px'
  },
  grid: {
    marginBottom: '5px',
    marginTop: '-85px'
  },
  pushPin: {
    marginLeft: '340px',
    marginTop: '-10px'
  },
  operationalText: {
    marginTop: '20px'
  },
  operationalText1: {
    marginTop: '-18px',
  },
  operationalWarScore: {
    marginLeft: '270px',
    marginTop: '-20px'
  },
  securityWarScore: {
    marginLeft: '270px',
    marginTop: '-32px'
  },
  securityText: {
    marginTop: '-32px'
  },
  reliabilityWarScore: {
    marginLeft: '270px',
    marginTop: '-32px'
  },
  reliabiltyText: {
    marginTop: '-32px'
  },
  performanceWarScore: {
    marginLeft: '270px',
    marginTop: '-32px'
  },
  performanceText: {
    marginTop: '-32px'
  },
  costOptimizationWarScore: {
    marginLeft: '270px',
    marginTop: '-32px'
  },
  costOptimizationText: {
    marginTop: '-32px'
  },
  securityAccreditationWarScore: {
    marginLeft: '270px',
    marginTop: '-30px'
  },
  securityAccreditationText: {
    marginTop: '-32px'
  }
}));

export type TemplateCardProps = {
  template: TemplateEntityV1beta3;
  deprecated?: boolean;
  setSelectedTemplate?: any;
  setMatchingEntities?: any;
  // localStorageArray?: any;
  index?: any;
  oldMatchingEntities?: any;
  selectedIndex?: any;
  selfServiceParam?:any;
  // openCard?: boolean;
  // tagIndex?: any;
};

type TemplateProps = {
  description: string;
  tags: string[];
  title: string;
  type: string;
  name: string;
  preRequisites1: any;
  preRequisites2: any;
  learnmore: any;
  learnmoregithub: any;
  learnmoretechdocs: any;
  warScore: any;
  info: any;
  warScoreDescription1: any;
  warScoreDescription2: any;
  operationalExcellence: any;
  security: any;
  reliability: any;
  performanceEfficiency: any;
  costOptimization: any;
  securityAccreditation: any;
  learnmoreSpecs: any;
  pillar: any;
  current_version:any;
};

const getTemplateCardProps = (
  template: TemplateEntityV1beta3,
): TemplateProps & { key: string } => {
  return {
    key: template.metadata.uid!,
    name: template.metadata.name,
    title: `${(template.metadata.title || template.metadata.name) ?? ''}`,
    type: template.spec.type ?? '',
    description: template.metadata.description ?? '-',
    tags: (template.metadata?.tags as string[]) ?? [],
    preRequisites1: template.metadata?.preRequisites1 || '',
    preRequisites2: template.metadata?.preRequisites2 || '',
    learnmore: template.metadata?.learnmore || '',
    learnmoregithub: template.metadata?.learnmoregithub || '',
    learnmoretechdocs: template.metadata?.learnmoretechdocs || '',
    warScore: template.metadata?.warScore || '',
    info: '',
    warScoreDescription1: 'While App Teams have the onus to design solutions based on Well Architected Frameworks, Blueprints help jumpstart with TMNA best practices and security standards built in. Please go through the linked Read Me documents to understand what you can do to further boost your WA scores.',
    warScoreDescription2: 'The total score is calculated by summing the number of satisfied WA pillar considerations (by blueprint) across all pillars and placing that over the sum of the number of applicable WA pillar considerations across all pillars. This gives a holistic view of the blueprints architectural alignment at a quick glance.',
    operationalExcellence: template.metadata?.operationalExcellence || '',
    security: template.metadata?.security || '',
    reliability: template.metadata?.reliability || '',
    performanceEfficiency: template.metadata?.performanceEfficiency || '',
    costOptimization: template.metadata?.costOptimization || '',
    securityAccreditation: template.metadata?.securityAccreditation || '',
    learnmoreSpecs: template.metadata?.learnmoreSpecs || '',
    pillar: template.metadata?.pillar || '',
    current_version:template.metadata?.current_version || '',
  };
};


export const TemplateCard = ({ template, index, selectedIndex, oldMatchingEntities
  , setMatchingEntities,selfServiceParam }: TemplateCardProps) => {
  const backstageTheme = useTheme<BackstageTheme>();
  const rootLink = useRouteRef(rootRouteRef);
  const templateProps = getTemplateCardProps(template);
  const learnmoreLink = templateProps.learnmore;
  const learnmoretechdocs = templateProps.learnmoretechdocs;
  const learnmoregithub = templateProps.learnmoregithub;
  const learnmoreLinkSpecs = templateProps.learnmoreSpecs;
  const pillar = templateProps.pillar;
  const navigate = useNavigate();

  const themeId = pageTheme[templateProps.type] ? templateProps.type : 'other';
  const theme = backstageTheme.getPageTheme({ themeId });
  const classes = useStyles({ backgroundImage: theme.backgroundImage });
  // const [selectedTemplate, setSelectedTemplate] = React.useState([] as any);
  const [selectedTemplate, setSelectedTemplate] = React.useState({} as any);
  // const [selectedSwapData, setSelectedSwapData] = React.useState({} as any);

  const [value, setvalue] = React.useState({} as any);
  const [maxvalue, setmaxvalue] = React.useState({} as any);
  const [valueSec, setvalueSec] = React.useState({} as any);
  const [maxvalueSec, setmaxvalueSec] = React.useState({} as any);
  const [valueReliability, setvalueReliability] = React.useState({} as any);
  const [maxvalueReliability, setmaxvalueReliability] = React.useState({} as any);
  const [valuePerformanceEff, setvaluePerformanceEff] = React.useState({} as any);
  const [maxvaluePerformanceEff, setmaxvaluePerformanceEff] = React.useState({} as any);
  const [valueCostOpt, setvalueCostOpt] = React.useState({} as any);
  const [maxvalueCostOpt, setmaxvalueCostOpt] = React.useState({} as any);
  const [valueSecurityAcc, setvalueSecurityAcc] = React.useState({} as any);
  const [maxvalueSecurityAcc, setmaxvalueSecurityAcc] = React.useState({} as any);
  const [open, setOpen] = React.useState(false);
  // const [tagindex, setTagindex] = React.useState({} as any);

  const handleCloseWarScoreCard = () => {
    setSelectedTemplate({});
    setOpen(false);

    setMatchingEntities(oldMatchingEntities)

    // window.scrollTo(0, 700);
  }
  const warScoreName = 'Well Architected Score'
  const onCardClick = React.useCallback(() => {
    let customPath = selfServiceParam?.selfService ? '/self-service' : rootLink()
    const href = generatePath(`${customPath}/templates/${templateProps.name}?learnMore=${learnmoreLink}`);
    navigate(href);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);



  const getmaxValue = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvalue(parseInt(a[0]));
    setmaxvalue(parseInt(a[1]));

  }
  const getmaxValueSecurity = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvalueSec(parseInt(a[0]));
    setmaxvalueSec(parseInt(a[1]));
  }

  const getmaxValueReliability = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvalueReliability(parseInt(a[0]));
    setmaxvalueReliability(parseInt(a[1]));
  }

  const getmaxValuePerformanceEff = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvaluePerformanceEff(parseInt(a[0]));
    setmaxvaluePerformanceEff(parseInt(a[1]));

  }
  const getmaxValueCostOpt = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvalueCostOpt(parseInt(a[0]));
    setmaxvalueCostOpt(parseInt(a[1]));
  }
  const getmaxValueSecurityAccrediation = (templateP: any) => {
    const b = templateP
    const a = b.split('/')
    setvalueSecurityAcc(parseInt(a[0]));
    setmaxvalueSecurityAcc(parseInt(a[1]));
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handleExpandClick = (templateProps: any) => {


    selectedIndex(index);

    // setSelectedTemplate([templateProps]);
    setSelectedTemplate(templateProps);

    // setMatchingEntities(templateProps);

    setOpen(!open)

    getmaxValue(templateProps.operationalExcellence);
    getmaxValueSecurity(templateProps.security);
    getmaxValueReliability(templateProps.reliability);
    getmaxValuePerformanceEff(templateProps.performanceEfficiency);
    getmaxValueCostOpt(templateProps.costOptimization);
    getmaxValueSecurityAccrediation(templateProps.securityAccreditation);

    if(open) {
      setMatchingEntities(oldMatchingEntities)
    }

  }


  // eslint-disable-next-line @typescript-eslint/no-shadow
  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 310,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #9B9C9D',
      padding: '5px',
      gridAutoFlow: 'initial'
    },
  }))(Tooltip);


  // console.log("selectedTemp", selectedTemplate.length)
  return (
    <Grid item xs={open ? 12 : 4}>
      <Card

        className={open ? classes.warCard : classes.card}
      // className={classes.card}
      >
        <CardContent className={classes.content}>
          {/* <Grid container alignItems="center" spacing={1}> */}
          <Grid item  >
            <TemplateCardIcon type={templateProps.type} />
          </Grid>
          <Grid item>
            <Typography variant="caption" className={classes.type}>
              {templateProps.type}
            </Typography>
          </Grid>
          {/* {templateProps.warScore} */}
          <div>

            {!selfServiceParam?.selfService && <Box className={classes.createWarButtonMargin}>
              {templateProps.warScore ? <Button variant="contained" type="submit" className={classes.createWarButton} style={{ textTransform: 'capitalize' }} onClick={() => handleExpandClick(templateProps)}>
                {warScoreName.charAt(0).toUpperCase() + warScoreName.slice(1)} {templateProps.warScore}
              </Button> : <Button variant="contained" type="submit" className={classes.createWarButton} disabled style={{ textTransform: 'capitalize', border: '0.5px solid #9B9C9D', backgroundColor: '#FFFFFF', color: '#9B9C9D' }} onClick={() => handleExpandClick(templateProps)}>
                {warScoreName.charAt(0).toUpperCase() + warScoreName.slice(1)} {templateProps.warScore}
              </Button>}

              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography variant="body1" style={{ font: 'bold', fontWeight: 700 }} color="inherit">Well Architected Score :</Typography>
                    This score quantifies how the blueprint stacks up based on common architectural principles across pillars such as Operational Excellence, Security, Reliability, Performance Efficiency, Cost Optimization, and TMNA Security Accreditation.
                  </React.Fragment>}>
                <InfoOutlinedIcon className={classes.InfoIcon} />
              </HtmlTooltip>
              {/* <Tooltip title="Well Architected Score :This score quantifies how the blueprint stacks up based on common architectural principles across pillars such as Operational Excellence, Security, Reliability, Performance Efficiency, Cost Optimization, and TMNA Security Accreditation.">
                <InfoOutlinedIcon className={classes.InfoIcon} > </InfoOutlinedIcon>
              </Tooltip> */}

            </Box>}
          </div>
          <div className={classes.titleContainer}>
            <Typography variant="h4">
              {templateProps.title}
            </Typography>
            <small style={{fontSize:'13px !important'}}>{templateProps.current_version}</small>
            {/* <NavigateNextIcon color="secondary" className={classes.arrowIcon}/> */}
          </div>
          {/* // CDX-1921, 1923, 1922 */}
          {/* {!open ? */}
          {
            templateProps.description.length > 74 && !open ?
              <HtmlTooltip placement="bottom" arrow title={templateProps.description} style={{ backgroundColor: '#FFFFFF', minWidth: '220px' }} color="primary">
                <span><Box className={classes.description} >
                  {templateProps.description}
                </Box></span>
              </HtmlTooltip>
              : <Box className={classes.description} >
                {templateProps.description}
              </Box>
          }
          {/* :
            <Box className={classes.description} >
              {templateProps.description}
            </Box>
          } */}
          <Box className={classes.preRequisites} style={{ marginLeft: '2px', font: 'bold', position: 'inherit' }}>
            {templateProps.preRequisites1 ? <Typography variant="body1" style={{ font: 'bold', fontWeight: 700 }}>
              Pre Requisites:
              <Typography variant="body2"> 1.    {templateProps.preRequisites1}
              </Typography>
            </Typography> : ''}
            {templateProps.preRequisites2 ?
              <Typography variant="body2"> 2.     {templateProps.preRequisites2}
              </Typography> : ''}

          </Box>
        </CardContent>

        <CardContent style={{ display: 'flex' }}>
          <Grid style={{ display: 'flex', flexDirection: 'column' }}>
            {!selfServiceParam?.selfService ? <div>Learn more about this Blueprint</div>:<div>Learn more about this Template</div>}
            <Grid item style={{ display: 'flex' }}>
              {learnmoretechdocs && <Link href={learnmoretechdocs} target="_blank">TechDocs</Link>}
               {(learnmoregithub && learnmoretechdocs) && <div style={{ marginLeft: '3px', marginRight: '3px' }}>|</div>}
              {learnmoregithub && <Link href={learnmoregithub} target="_blank">GitHub</Link>}
            </Grid>
          </Grid>
        </CardContent>

        {/* <CardActions className={classes.cardActions}> */}
        {/* <Box> */}
        {/* {templateProps.tags?.length < 4 && templateProps.tags?.map(tag => ( */}
        {/* {templateProps.tags?.slice(0, 2).map(tag => (
              <Chip size="small" label={tag} key={tag} />
            ))} */}
        {/* </Box> */}
        {/* </CardActions> */}
        <Box className={classes.createButtonMargin}>
          <Button variant="contained" type="submit" className={classes.createButton} onClick={onCardClick}>
            Create
          </Button>
        </Box>

        {/* {console.log("selectedTemplate1", openCard)} */}
        {open && <div className={classes.warCard}>
          {/* {console.log("selectedTemplate3", selectedTemplate)} */}

          <Grid container className={classes.grid} spacing={3} style={{ marginLeft: '510px' }}>
            {/* <Grid className={classes.gridItem} item>
                      <Typography variant="caption" className={classes.type}>
                        {selectedTemplate.type}
                        
                      </Typography>
                      <Box className={classes.createWarButtonMargin}>
                        <Button variant="contained" type="submit" className={classes.createWarButton} style={{ fontSize: '14px' }} onClick={() => handleExpandClick(template)}>
                          
                          {warScoreName.charAt(0).toUpperCase() + warScoreName.slice(1)} {selectedTemplate.warScore}
                          
                        </Button>
                        <InfoIcon className={classes.InfoIcon} ></InfoIcon>
                      </Box>

                      <div className={classes.titleContainer} style={{ margin: '20px' }}>
                        <Typography variant="h3">
                          {selectedTemplate.title}
                        </Typography>
                      </div>
                      <Box className={classes.description}>
                        {selectedTemplate.description}
                      </Box>
                      <div className={classes.preRequisites} style={{ marginLeft: '25px', font: 'bold' }}>
                        <Typography>
                          Pre Requisites:
                          <Typography>
                            {selectedTemplate.preRequisites1}
                          </Typography>
                          {selectedTemplate.preRequisites2}
                        </Typography>
                      </div>
                      <Link href={learnmoreLink} target="_blank" style={{ marginTop: '130px', marginLeft: '20px' }}>Learn More</Link>

                      <Box className={classes.createButtonMargin}>
                        <Button variant="contained" type="submit" className={classes.createButton} onClick={onClickCreate}>
                          Create
                        </Button>
                      </Box>
                      <Box>
                        {selectedTemplate.tags?.map((tag: any) => (
                          <Chip size="small" label={tag} key={tag} style={{ marginLeft: '20px', marginTop: '20px' }} />
                        ))}
                      </Box>
                    </Grid> */}
            <Grid item className={classes.gridDivider}>
              <Divider orientation="vertical" className={classes.divider} />
            </Grid>
            <Grid container>
              <Grid className={classes.gridItem1} style={{ marginTop: '-495px', marginLeft: '-182px' }} item>
                <Grid container className={classes.gridItem}>

                  <Grid item>
                    <div className={classes.titleWarRightGrid} style={{ font: 'bold', fontSize: '18px' }}>
                      <Typography variant="h4">
                        WA Score {selectedTemplate.warScore}
                      </Typography>
                    </div>
                  </Grid>

                  <div className={classes.warDescription} style={{ marginLeft: '4px', fontSize: '14px' }}>
                    <Typography variant="body2" >
                      {selectedTemplate.warScoreDescription1}
                    </Typography>
                  </div>
                  <Grid item>
                    <div onClick={handleCloseWarScoreCard} className={classes.closeButton} aria-hidden="true"><CloseIcon /></div>
                  </Grid>
                </Grid>

                <div className={classes.titleWarRightGridDesc} style={{ fontSize: '14px', marginTop: '-16px' }}>
                  <Typography>
                    <div className={classes.operationalText} style={{ marginTop: '20px', font: 'bold' }}>
                      <Typography variant="body2" > Operational Excellence </Typography> <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '170px' }}> {selectedTemplate.operationalExcellence}</Typography>
                    </div>
                    <div className={classes.operationalWarScore} style={{ marginTop: '-32px' }}>
                      <TemplateWarScore
                        value={parseInt(value)}
                        maxValue={parseInt(maxvalue)}
                      />
                    </div>
                    <Typography>
                      <div className={classes.securityText}>
                        <Typography variant="body2" > Security </Typography>  <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '65px' }}> {selectedTemplate.security}</Typography>
                      </div>
                      <div className={classes.securityWarScore} >
                        <TemplateWarScore
                          value={parseInt(valueSec)}
                          maxValue={parseInt(maxvalueSec)}
                        />
                      </div>
                      <Typography>
                        <div className={classes.reliabiltyText}>
                          <Typography variant="body2" > Reliability </Typography> <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '68px' }}> {selectedTemplate.reliability}</Typography>
                        </div>
                        <div className={classes.reliabilityWarScore} >
                          <TemplateWarScore
                            value={parseInt(valueReliability)}
                            maxValue={parseInt(maxvalueReliability)}
                          />
                        </div>
                        <Typography>
                          <div className={classes.performanceText}>
                            <Typography variant="body2" > Performance Efficiency </Typography> <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '162px' }}>  {selectedTemplate.performanceEfficiency}</Typography> </div>
                          <div className={classes.performanceWarScore}>
                            <TemplateWarScore
                              value={parseInt(valuePerformanceEff)}
                              maxValue={parseInt(maxvaluePerformanceEff)}
                            />
                          </div>
                          <Typography>
                            <div className={classes.costOptimizationText}>
                              <Typography variant="body2" > Cost Optimization </Typography> <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '128px' }}> {selectedTemplate.costOptimization} </Typography> </div>
                            <div className={classes.costOptimizationWarScore}>
                              <TemplateWarScore
                                value={parseInt(valueCostOpt)}
                                maxValue={parseInt(maxvalueCostOpt)}
                              />

                            </div>
                            <Typography>
                              <div className={classes.securityAccreditationText}>
                                <Typography variant="body2" >  [TMNA] Security Accreditation </Typography> <Typography variant="h1" className={classes.operationalText1} style={{ fontSize: '14px', font: 'bold', marginLeft: '210px' }}> {selectedTemplate.securityAccreditation} </Typography> </div>
                              <div className={classes.securityAccreditationWarScore}>
                                <TemplateWarScore
                                  value={parseInt(valueSecurityAcc)}
                                  maxValue={parseInt(maxvalueSecurityAcc)}
                                />
                              </div>
                            </Typography>
                          </Typography>
                        </Typography>
                      </Typography>
                    </Typography>
                  </Typography>
                </div>
                <div className={classes.warDescription1} style={{ fontSize: '14px', maxWidth: '595px' }}>
                  <Typography variant="body2">
                    {selectedTemplate.warScoreDescription2}
                    {/* <div className={classes.learnMore}> */}
                    <Link href={learnmoreLinkSpecs} target="_blank">    Learn more about this blueprint</Link>
                    <div>
                      Be sure to check <Link href={pillar} target="_blank">Pillars</Link> section of the WA assessment for this Blueprint to boost your WA score.
                    </div>
                    {/* </div> */}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>}
      </Card>
    </Grid >
  );
};